<template>
  <div class="mt-10">
    <span class="propInfoTitle">2. 매물 정보</span>
    <card class="mt-15 px-0">
      <div slot="header">
        <h3 class="card-title">건축물 정보</h3>
      </div>
      <div class="row m-row">
        <!-- 용도지역 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">용도지역</label>
          <div class="fl col-8 pl-0">
            <el-input v-model="this.brdListForInput" disabled></el-input>
          </div>
        </div>

        <!--대지면적 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">대지면적</label>
          <div class="fl col-8 pl-0">
            <el-input v-model="certification.platArea" disabled>
              <template slot="append">m²</template>
            </el-input>
          </div>
        </div>

        <!--연면적 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">연면적</label>
          <div class="fl col-8 pl-0">
            <el-input v-model="certification.totArea" disabled>
              <template slot="append">m²</template>
            </el-input>
          </div>
        </div>

        <!-- 건축물 용도 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">
            건축물용도
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                건축물 주용도는 건축물대장, 정부와 공공기관이 공개한
                <br />자료를 바탕으로 자동 입력됩니다. <br />(자료의 기준시점에
                따라 일치하지 않을 수 있습니다.) <br />집비오의 매물유형은
                주용도에 따라 아파트, 빌라, 주택 <br />으로 카테고리가 자동
                분류됩니다.
                <br />
                <br />
                <el-table :data="clsfData" size="mini" border>
                  <el-table-column
                    prop="clsfByJv"
                    label="집비오 분류"
                    width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="purpsDetail"
                    label="건축물 세부용도"
                    width="150"
                  ></el-table-column>
                  <el-table-column
                    prop="purps"
                    label="건출물용도(건축법)"
                    width="150"
                  ></el-table-column>
                </el-table>
              </div>
              <i class="fas fa-exclamation-circle jipvio-color1"></i>
            </el-tooltip>
          </label>
          <div class="fl col-8 pl-0">
            <el-input v-model="purpString" disabled></el-input>
          </div>
        </div>
        <!-- 건축물 세부용도 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">세부용도</label>
          <div class="fl col-8 pl-0">
            <el-input v-model="certification.purpsDetail" disabled></el-input>
          </div>
        </div>

        <!--총세대수 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">총 세대수</label>
          <div class="fl col-8 pl-0">
            <el-input v-model="certification.hhldCnt" disabled>
              <template slot="append">세대</template>
            </el-input>
          </div>
        </div>

        <!--명칭 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">명칭</label>
          <div class="fl col-8 pl-0">
            <el-input v-model="certification.bdNm" disabled> </el-input>
          </div>
        </div>

        <!--사용승인 일자 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">사용승인 일자</label>

          <div class="fl col-8 pl-0">
            <el-input v-model="certification.useAprDay" disabled></el-input>
          </div>
        </div>

        <!-- 총 주차대수 -->
        <div class="fl col-lg-4 col-md-6 col-sm-6 px-0 mb-10">
          <label class="fl col-4 col-form-label px-0">총 주차대수</label>
          <div class="fl col-8 pl-0">
            <el-input v-model="certification.totPkngCnt" disabled>
              <template slot="append">대</template>
            </el-input>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

import { Card, Button, Input, Tooltip, Table, TableColumn } from "element-ui";

export default {
  components: {
    Card,
    [Button.name]: Button,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },

  data() {
    return {
      clsfData: [
        {
          clsfByJv: "아파트",
          purpsDetail: "아파트",
          purps: "공동주택"
        },
        {
          clsfByJv: "빌라",
          purpsDetail: "다세대, 연립",
          purps: "공동주택"
        },
        {
          clsfByJv: "주택",
          purpsDetail: "단독, 다중, 다가구",
          purps: "단독주택"
        },
        {
          clsfByJv: "오피스텔",
          purpsDetail: "업무시설(오피스텔)",
          purps: "업무시설"
        },
        {
          clsfByJv: "원룸",
          purpsDetail: "정의되어 있지 않음",
          purps: "정의되어 있지 않음"
        }
      ]
    };
  },

  created() {},

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    certification() {
      return this.sessionPropertyInquiry.certification;
    },

    contractInfo() {
      return this.sessionPropertyInquiry.contractInfo;
    },

    brdListForInput() {
      let brdL = "";

      if (this.certification.brdList != null) {
        if (this.certification.brdList.length == 1) {
          return this.certification.brdList[0];
        } else {
          for (var i = 0; i < this.certification.brdList.length - 1; i++) {
            brdL = brdL + this.certification.brdList[i] + ",";
          }
          return (
            brdL +
            this.certification.brdList[this.certification.brdList.length - 1]
          );
        }
      } else {
        return null;
      }
    },
    purpString() {
      if (this.certification.purpsDetail != null) {
        const purp = this.certification.purpsDetail;
        if (
          purp.search("아파트") != -1 ||
          purp.search("다세대") != -1 ||
          purp.search("연립") != -1 ||
          purp.search("공동주택") != -1
        ) {
          return "공동주택";
        } else if (
          purp.search("단독") != -1 ||
          purp.search("다중") != -1 ||
          purp.search("다가구") != -1
        ) {
          return "단독주택";
        } else if (
          purp.search("오피스텔") != -1 ||
          purp.search("업무시설") != -1
        ) {
          return "업무시설";
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  },

  methods: {}
};
</script>

<style></style>
